import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Card } from "@/components/ui/card";
import { useEffectivePermissions, useHasPermission } from "@/lib/auth/permissions";

export function InventoryGuard() {
  const { t } = useTranslation();
  const { isLoading: permsLoading } = useEffectivePermissions();
  const hasPoRead = useHasPermission("inventory.po.read");
  const hasSupplierRead = useHasPermission("inventory.supplier.read");
  const hasApRead = useHasPermission("inventory.ap.read");
  const canView = hasPoRead || hasSupplierRead || hasApRead;

  if (permsLoading) return null;

  if (!canView) {
    return (
      <div className="p-6 max-w-6xl mx-auto">
        <Card className="text-sm text-ink-500 p-6">{t("rbac.noAccess")}</Card>
      </div>
    );
  }

  return <Outlet />;
}
